import * as yup from 'yup';

export const MealComponentSchema = yup.object({
  name: yup.string().required(),
  kcal: yup.number().required().min(0),
  ml: yup.number().notRequired().nullable().min(0),
  portion: yup.number().notRequired().min(0).default(1),
});

export const UpdateMealComponentsSchema = yup.object({
  id: yup.string().required(),
  mealComponents: yup.array().of(MealComponentSchema).default([]),
});

export type IMealComponent = {
  name: string;
  kcal: number;
  ml?: number | null;
  portion?: number;
};

export interface IUpdateMealComponents {
  id: string;
  mealComponents: IMealComponent[];
}
